import { useState, useRef, useEffect } from "react";
import { ChevronDown } from "lucide-react";

const Dropdown = ({ options = [], value, onChange, placeholder = "Select" }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const selected = options.find((o) => o.value === value);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div ref={ref} className="relative min-w-[120px] sm:min-w-[180px]">
      <button
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between gap-2 border-0 px-3 sm:px-4 py-3 text-xs sm:text-sm text-gray-700 hover:bg-gray-50 transition-colors bg-white"
      >
        <span>{selected?.label ?? placeholder}</span>
        <ChevronDown size={14} className={`text-gray-400 transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
      </button>

      {open && (
        <ul className="absolute px-1 z-50 top-full left-0 right-0 mt-1 bg-white border border-gray-200 shadow-md">
          {options.map((o) => (
            <li key={o.value}>
              <button
                onClick={() => { onChange(o.value); setOpen(false); }}
                className={`w-full text-left px-4 py-2.5 text-sm transition-colors hover:bg-gray-50 ${
                  o.value === value ? "border-l-2 border-gray-900 text-gray-900 font-medium" : "text-gray-600 border-l-2 border-transparent"
                }`}
              >
                {o.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Dropdown;
